import { create } from 'zustand';
import type { ReleaseDrawerTab } from '@/utils/releaseLinks';

export type { ReleaseDrawerTab };

/** Where the open request came from (the drawer hides Edit for 'composer'). */
export type ReleaseDrawerSource = 'board' | 'list' | 'composer' | 'notification' | 'dashboard' | 'link';

export interface ReleaseDrawerTarget {
  postId: number;
  /** null = the Original */
  variationId: number | null;
  tab?: ReleaseDrawerTab;
  /** Board drag to "Changes requested": the drawer opens with the composer in changes mode */
  openInChangesMode?: boolean;
  source?: ReleaseDrawerSource;
}

interface ReleaseDrawerState {
  target: ReleaseDrawerTarget | null;
  /** Bumps on every open() so the drawer remounts with fresh state, even for the same post */
  token: number;
  open: (target: ReleaseDrawerTarget) => void;
  close: () => void;
}

let nextToken = 1;

/**
 * The single global Release drawer state (SSOT). Only ReleaseDrawerHost renders the drawer.
 * The URL is an input only (see ReleaseDrawerHost intake), never mirrored from this state.
 */
export const useReleaseDrawerStore = create<ReleaseDrawerState>((set) => ({
  target: null,
  token: 0,
  open: (target) => set({ target, token: nextToken++ }),
  close: () => set({ target: null }),
}));

/** Open the global Release drawer from anywhere (no hook needed in event handlers). */
export const openReleaseDrawer = (target: ReleaseDrawerTarget): void => {
  useReleaseDrawerStore.getState().open(target);
};
